<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <paginated-table 
            v-if="isLoaded" 
            :title="tableTitle" 
            :icon="tableIcon" 
            :columns="columns" 
            :data="reviews"
            @updatePagination="updatePagination"
            ></paginated-table>
        </div>
    </div>
</template>
<script>
    import PaginatedTable from '@/components/Tables/PaginatedTable.vue'
    import { getCompletedReviewColumns } from '@/views/ReviewView/columns'
    import { completedReviewLabel } from '@/views/ReviewView/label'

    import { reviewApi } from '@/api/api';

    export default {
        components: {
            PaginatedTable,
        },
        data() {
            return {
                // label
                tableTitle: completedReviewLabel.tableTitle,
                tableIcon: "done_outline",

                // fields & columns
                columns: getCompletedReviewColumns({
                    "description" : this.toShowReview,
                }),

                // boolean
                isLoaded: false,

                // init data
                reviews: {
                    page_info: {
                        page: 1,
                        size: 5,
                        total_elements: 5,
                        total_pages: 1,
                    },
                    elements: [],
                },
            }
        },
        methods: {
            /**
             * 수정 작업 처리 메소드 
             */
             toShowReview(review) {
                this.$router.push({
                    name: "review-detail",
                    params:{
                        idx: review.idx,
                    }
                });
            },
            /**
             * 리뷰 목록 조회 API 요청 메서드
             */
             fetchReviews(size, page) {
                const params = {
                    reviewer_idx: 3, // TODO 로그인 연동 완료되면 수정
                    is_completed: true,
                    size: size,
                    page: page,
                    sort_by: "idx", 
                    direction: "desc",
                };

                this.isLoaded = false;
                reviewApi.getReviews(params).then(response => {
                    if (response && response.status === 200) {
                        this.reviews = response.data.response;
                        this.isLoaded = true;
                    }else {
                        this.review = true;
                        alert(completedReviewLabel.apiRequestFailMessage);
                    }
                })
            },
            /**
             * Pagination 타입 명세
             * @typedef {Object} Conditions
             * @property {string} page - 페이지
             * @property {string} size - 사이즈
             * @property {string} total_elements - 전체 데이터 수 
             * @property {string} total_pages - 전체 페이지 수
             */

            /** 
             * 페이지네이션 업데이트 메서드
             *  
             * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
             * @params {Pagination} pagination
             */
             updatePagination(pagination) {
                this.reviews.page_info.size = pagination.size;
                this.reviews.page_info.page = pagination.page;

                this.fetchReviews(this.reviews.page_info.size, this.reviews.page_info.page);
            },
        },
        mounted() {
            this.fetchReviews(this.reviews.page_info.size, this.reviews.page_info.page);
        },
    }
</script>
<style scoped></style>